<template lang="pug">
  article.post-single(
    :id="`post-${post.id}`"
  )
    post-header(:post="post")

    post-content(
      :post="post"
    )

    post-footer(
      :post="post"
    )
</template>
<script>
import PostHeader from '@/components/post/post-header'
import PostContent from '@/components/post/post-content'
import PostFooter from '@/components/post/post-footer'

export default {
  name: 'post-single',
  components: {
    PostHeader,
    PostContent,
    PostFooter,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
}
</script>